module.exports = "/assets/sample3-bcc72150e4050a27f9bd96638a2debbe.jpg";